"use client";

import { c as _c } from "react/compiler-runtime";
import { LocalAlert } from "@navikt/ds-react";
import { LocalAlertCloseButton, LocalAlertContent, LocalAlertHeader, LocalAlertTitle } from "@navikt/ds-react/LocalAlert";
import { useState } from "react";
import MeldUnntakForm from "./MeldUnntakForm";
interface Props {
  ansattNavn: string;
}
export default function MeldUnntakSection(t0) {
  const $ = _c(7);
  const {
    ansattNavn
  } = t0;
  const [erSendt, setErSendt] = useState(false);
  if (!erSendt) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = () => setErSendt(true);
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== ansattNavn) {
      t2 = <MeldUnntakForm ansattNavn={ansattNavn} onSuccess={t1} />;
      $[1] = ansattNavn;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LocalAlertTitle as="h3">Meldingen er sendt til Nav og den ansatte</LocalAlertTitle>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LocalAlertHeader>{t1}<LocalAlertCloseButton onClick={() => setErSendt(false)} /></LocalAlertHeader>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== ansattNavn) {
    t3 = <LocalAlert status="success">{t2}<LocalAlertContent>Nav har registrert at det ikke er aktuelt med en oppfølgingsplan for{" "}{ansattNavn} nå. Endrer situasjonen seg, kan det bli aktuelt at dere lager en plan.</LocalAlertContent></LocalAlert>;
    $[5] = ansattNavn;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}